import module from 'nominas/nomina/module.js'

const schema = {
  pago_id: 'number',
  importe: 'number',
  id_metodo_pago: 'number',
  id_moneda: 'number',
  id_tipo_pago: 'number',
}

export class NominasNominaBancosRecibosService {
  constructor ($http) {
    this.$http = $http
  }

  get (idNomina) {
    return this.$http.get('/api/nominas/nomina/bancos/pagos', {
      params: {
        idNomina: idNomina,
      },
      schema,
    })
  }
}

module.service('NominasNominaBancosRecibos', NominasNominaBancosRecibosService)



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Bancos/Recibos.js